var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mb-4 text-center"},[_vm._v("Sign up")]),_c('sign-up2-form',{attrs:{"formType":"jwt"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }